// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors, fonts } from '@toggl/style'

type Props = {|
  +background?: string,
  +children: React.Node,
|}

export const Banner = ({ children, ...props }: Props) => (
  <Root {...props}>
    <Wrapper>
      <Alert />
      {children}
    </Wrapper>
  </Root>
)

const Root: React.ComponentType<any> = styled.div`
  padding: 25px;
  background: ${(p) => p.background || colors.yellow80};
  font-family: ${fonts.gtHaptikMedium};
  color: ${colors.darkPurple100};
`

const Wrapper = styled.div`
  max-width: 1140px;
  margin: auto;
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;

  > * {
    flex: 0 auto;
  }
  a {
    line-height: 1;
  }
`

const Alert = styled.div`
  width: 12px;
  height: 12px;
  background: ${colors.pink100};
  border-radius: 100%;
  box-shadow: 0 0 0 rgba(229, 124, 216, 0.4);
  animation: glow 2s cubic-bezier(0.5, 0, 1, 1) infinite;
  @keyframes glow {
    0% {
      box-shadow: 0 0 0 0 rgba(229, 124, 216, 0.6);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(229, 124, 216, 0);
    }
  }
`
